
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
} from "vue";
import TitleVue from "./components/Title.vue";
import SummaryVue from "./components/Summary.vue";
import EducationVue from "./components/Education.vue";
import WorkVue from "./components/Work.vue";
import ProjectsVue from "./components/Projects.vue";

export default defineComponent({
  setup() {
    const darkMode = ref(false);
    const sitePreference = localStorage.getItem("darkmode");
    if (sitePreference === null) {
      const changeListener = (event: MediaQueryListEvent) => {
        const sitePreference = localStorage.getItem("darkmode");
        if (sitePreference !== null) {
          return;
        }
        darkMode.value = event.matches;
      };
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      onMounted(() => mediaQuery.addEventListener("change", changeListener));
      onBeforeUnmount(() =>
        mediaQuery.removeEventListener("change", changeListener)
      );
      darkMode.value = mediaQuery.matches;
    } else {
      darkMode.value = sitePreference === "dark";
    }
    return { darkMode };
  },
  name: "App",
  components: {
    TitleVue,
    SummaryVue,
    EducationVue,
    WorkVue,
    ProjectsVue,
  },
  methods: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.setItem("darkmode", this.darkMode ? "dark" : "light");
    },
  },
});
